/**
 * Created by Astha on 5/10/2018.
 */
//@flow
import {Logger} from "../../logger/Logger";
import {
  GetCollectionSettingsMessage,
  GetCollectionSettingsQuery,
  GetCollectionSettingsResponse
} from "../../autogenerated/ZoomBridge";


export default class GetCollectionSettings {

  logger: Logger;
  _collectionId: number;
  _userId: string;
  _doNotUserAuthenticator: boolean;


  constructor(collectionId: number, userId: string) {
    this.logger = new Logger('GetCollectionSettings');
    this._collectionId = collectionId;
    this._userId = userId;
  }

  doNotUserAuthenticator() {
    this._doNotUserAuthenticator = true;
  }

  getCollectionSettings(): Promise<GetCollectionSettingsResponse> {
    const query: GetCollectionSettingsQuery = new GetCollectionSettingsQuery();
    const message: GetCollectionSettingsMessage = new GetCollectionSettingsMessage();
    message.setCollectionId(this._collectionId);
    message.setUserId(this._userId);
    query.message = message;
    if (this._doNotUserAuthenticator) {
      query.setAuthenticator(null);
    }
    return query.run();
  }


}
